// // import React from "react";
// // import classes from "./CartCheckOut.module.scss";
// // import CartItem from "./CartItem";
// // import productList from "./productData";

// // const CartCheckOut = ({ cart, updateQuantity, increment, decrement }) => {
// //   // Ensure cart is an array of items
// //   const items = cart && cart.items ? cart.items : [];

// //   // Calculate total price using reduce
// //   const totalPrice = items.reduce(
// //     (acc, item) => acc + item.price * item.quantity,
// //     0
// //   );

// //   return (
// //     <section className={classes.cart_checkOut}>
// //       <section className={`${classes.container} ${classes.checkOut_container}`}>
// //         <div className={classes.checkOut}>
// //           <div className={`${classes.checkout_child} ${classes.cart_head}`}>
// //             <span className={classes.number_of_items}>
// //               CART ({items.length})
// //             </span>
// //             <span className={classes.remove_all} onClick={() => updateQuantity}>
// //               Remove All
// //             </span>
// //           </div>
// //           <section
// //             className={`${classes.addedItems} ${classes.checkout_child}`}
// //           >
// //             {productList.map((product) => {
// //               return (
// //                 <div className={`${classes.addedItem}`} key={product.id}>
// //                   <section className={classes.addedItem_leftSide}>
// //                     <img src={product.img} alt="Product" />
// //                     <div className={classes.product_price}>
// //                       <span>{product.title}</span>
// //                       <span>{`$${product.price.toFixed(2)}`}</span>
// //                     </div>
// //                   </section>
// //                   <div className={classes.counter}>
// //                     <span
// //                       className={classes.increment}
// //                       onClick={() => increment(product.id)}
// //                     >
// //                       +
// //                     </span>
// //                     <span className={classes.value}>{product.quantity}</span>
// //                     <span
// //                       className={classes.decrement}
// //                       onClick={() => decrement(product.id)}
// //                     >
// //                       -
// //                     </span>
// //                   </div>
// //                 </div>
// //               );
// //             })}
// //           </section>
// //           <div className={`${classes.total} ${classes.checkout_child}`}>
// //             <span className={classes.total_text}>Total</span>
// //             <span className={classes.total_amount}>{`$${totalPrice.toFixed(
// //               2
// //             )}`}</span>
// //           </div>
// //           <button
// //             className={`${classes.checkout_button} ${classes.checkout_child}`}
// //           >
// //             checkout
// //           </button>
// //         </div>
// //       </section>
// //     </section>
// //   );
// // };

// // export default CartCheckOut;
import React from "react";
import classes from "./CartCheckOut.module.scss";
import CartItem from "./CartItem";
import productList from "./productData";
import { useState, useContext } from "react";
import { Link } from "react-router-dom";
import CheckoutForm from "../CheckOutForm/CheckoutForm";

const CartCheckOut = ({ cart, updateQuantity, quantity, key }) => {
  const [initialQuantity, setInitialQuantity] = useState(quantity);
  const increment = () => {
    setInitialQuantity((a) => a + 1);
  };
  const decrement = () => {
    setInitialQuantity((a) => a - 1);
  };
  // Ensure cart is an array of items
  const items = cart && cart.items ? cart.items : [];

  // Calculate total price using reduce
  const totalPrice = items.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  const removeItem = (itemId) => {
    updateQuantity(itemId, 0); // Update quantity to 0 to remove item from cart
  };

  return (
    <section className={classes.cart_checkOut}>
      <section className={`${classes.container} ${classes.checkOut_container}`}>
        <div className={classes.checkOut}>
          <div className={`${classes.checkout_child} ${classes.cart_head}`}>
            <span className={classes.number_of_items}>
              CART ({items.length})
            </span>
            <span className={classes.remove_all} onClick={() => updateQuantity}>
              Remove All
            </span>
          </div>
          <section
            className={`${classes.addedItems} ${classes.checkout_child}`}
          >
            {productList.map((product) => {
              const cartItem = items.find((item) => item.id === product.id);
              return (
                <div className={`${classes.addedItem}`} key={product.id}>
                  <section className={classes.addedItem_leftSide}>
                    <img src={product.img} alt="Product" />
                    <div className={classes.product_price}>
                      <span>{product.title}</span>
                      <span>{`$${product.price.toFixed(2)}`}</span>
                    </div>
                  </section>
                  <div className={classes.counter}>
                    <span
                      className={classes.increment}
                      onClick={() => increment(product.quantity)}
                    >
                      +
                    </span>
                    <span className={classes.value}>
                      {initialQuantity}
                      {/* {cartItem ? cartItem.quantity : 0} */}
                    </span>
                    <span
                      className={classes.decrement}
                      onClick={() => decrement(product.quantity)}
                    >
                      -
                    </span>
                  </div>
                  {cartItem && cartItem.quantity === 0 && (
                    <button
                      className={classes.removeFromCart}
                      onClick={() => removeItem(product.id)}
                    >
                      Remove From Cart
                    </button>
                  )}
                </div>
              );
            })}
          </section>
          <div className={`${classes.total} ${classes.checkout_child}`}>
            <span className={classes.total_text}>Total</span>
            <span className={classes.total_amount}>{`$${totalPrice.toFixed(
              2
            )}`}</span>
          </div>
          {/* <button
            className={`${classes.checkout_button} ${classes.checkout_child}`}
          >
            checkout
          </button> */}
          <Link
            className={`${classes.checkout_button} ${classes.checkout_child}`}
            to={"/checkoutform"}
          >
            checkout
          </Link>
        </div>
      </section>
    </section>
  );
};

export default CartCheckOut;

// import React from "react";
// import classes from "./CartCheckOut.module.scss";
// import productList from "./productData";

// const CartCheckOut = ({ cart, updateQuantity }) => {
//   const items = cart && cart.items ? cart.items : [];

//   const totalPrice = items.reduce(
//     (acc, item) => acc + item.price * item.quantity,
//     0
//   );

//   const handleQuantityChange = (productId, delta) => {
//     const item = items.find((item) => item.id === productId);
//     if (item) {
//       const newQuantity = item.quantity + delta;
//       updateQuantity(productId, newQuantity > 0 ? newQuantity : 0);
//     }
//   };

//   const removeAllItems = () => {
//     items.forEach((item) => updateQuantity(item.id, 0));
//   };

//   return (
//     <section className={classes.cart_checkOut}>
//       <section className={`${classes.container} ${classes.checkOut_container}`}>
//         <div className={classes.checkOut}>
//           <div className={`${classes.checkout_child} ${classes.cart_head}`}>
//             <span className={classes.number_of_items}>
//               CART ({items.length})
//             </span>
//             <span className={classes.remove_all} onClick={removeAllItems}>
//               Remove All
//             </span>
//           </div>
//           <section
//             className={`${classes.addedItems} ${classes.checkout_child}`}
//           >
//             {productList.map((product) => {
//               const cartItem = items.find((item) => item.id === product.id);
//               return cartItem ? (
//                 <div className={`${classes.addedItem}`} key={product.id}>
//                   <section className={classes.addedItem_leftSide}>
//                     <img src={product.img} alt={product.title} />
//                     <div className={classes.product_price}>
//                       <span>{product.title}</span>
//                       <span>${product.price.toFixed(2)}</span>
//                     </div>
//                   </section>
//                   <div className={classes.counter}>
//                     <span
//                       className={classes.increment}
//                       onClick={() => handleQuantityChange(product.id, 1)}
//                     >
//                       +
//                     </span>
//                     <span className={classes.value}>{cartItem.quantity}</span>
//                     <span
//                       className={classes.decrement}
//                       onClick={() => handleQuantityChange(product.id, -1)}
//                     >
//                       -
//                     </span>
//                   </div>
//                   <button
//                     className={classes.removeFromCart}
//                     onClick={() => updateQuantity(product.id, 0)}
//                   >
//                     Remove From Cart
//                   </button>
//                 </div>
//               ) : null;
//             })}
//           </section>
//           <div className={`${classes.total} ${classes.checkout_child}`}>
//             <span className={classes.total_text}>Total</span>
//             <span className={classes.total_amount}>
//               ${totalPrice.toFixed(2)}
//             </span>
//           </div>
//           <button
//             className={`${classes.checkout_button} ${classes.checkout_child}`}
//           >
//             Checkout
//           </button>
//         </div>
//       </section>
//     </section>
//   );
// };

// export default CartCheckOut;
